module.exports = new __parcel__URL__("ogre-spray.756de276.webp").toString();